import {Component, OnDestroy, OnInit} from "@angular/core";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {STORAGE_CATEGORIES_LIST} from "../../../enums/e-storage-categories";
import {UI_TEXTS} from "../../../enums/e-texts";
import {ResourceMetricsService} from "../../../services/resource-metrics.service";
import {GoBaseComponent} from "../go-base.component";
import {IResourceMetrics} from "../../../interfaces/resource-metrics.definition";
import {Subject} from "rxjs/Subject";
import {isUndefined} from "util";
import {JP} from "../../../helpers/jp";


@Component({
  selector: "go-resource",
  templateUrl: "./go-resource.component.html"
})


export class GoResourceComponent extends GoBaseComponent implements OnInit, OnDestroy {
  STORAGE_CATEGORIES = STORAGE_CATEGORIES_LIST;
  UI_TEXTS = UI_TEXTS;

  resourceMetrics:IResourceMetrics = <IResourceMetrics>{
    prodTime: -1,
    buyCost: -1,
    deep: -1,
    weight: -1
  };

  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private resourceMetricsService: ResourceMetricsService) {
    super(GO_COMPONENTS.RESOURCE);
  }



  ngOnInit(): void {
  }


  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  onAutoRefillUpdated(val:boolean):void{
    if (!val)
    {
      JP.remove(this.component,"/autoRefill");
    }
  }

  protected onDocumentSet() {
    super.onDocumentSet();

    this.resourceMetricsService
      .loadMetrics(this.document.id)
      .takeUntil(this.unsubscribe)
      .subscribe(json => this.resourceMetrics = json);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-resource/go-resource.component.ts